import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asesoria',
  templateUrl: './asesoria.component.html',
  styles: []
})
export class AsesoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
